<template>
    <b-row>
        <b-col cols="12">
            <b-button
                class="m-3"
                :to="{
                    name: 'back.events.sesion.reservas',
                    params: { evento_id: evento.id, sesion_id: sesion.id }
                }"
            >
                Listado de reservas generadas
            </b-button>
            <Button v-if="paso > 1" class="m-3" @click="cambiarPaso(1, true)">Cambiar zona</Button>
        </b-col>
        <b-col cols="12" v-if="! zona_seleccionada">
            <b-tabs pills card align="center">
                <b-tab title="Svg" active>
                    <template v-if="evento.place_obj.tipo_svg === 1 && paso === 1 && evento.place_obj.tipo_proceso_taquilla === 1">
                        <CleSvgComponent
                            v-if="zonas.length > 0"
                            :zonas="zonas"
                            :place="evento.place_obj"
                            :sesion_id="sesion.id"
                            @clickZona="zonaSeleccionada" 
                        />
                    </template>
                    <template v-else-if="evento.place_obj.tipo_svg === 2">
                        <SelectButacasBloqueadosComponent 
                            v-if="evento"
                            :recinto_id="evento.place_obj.id"
                            :evento_id="evento.id"
                            :sesion_id="sesion.id"
                            @clickPlaza="clickPlaza" 
                            :key="resetKey"
                        />
                    </template>
                    <SeccionesComponent
                        v-else
                        :event="evento"
                        :sesion_id="parseInt(sesion.id)"
                        @terminar="goTo(2, $event)"
                    />                    
                </b-tab>
                <b-tab title="Listado" v-if="evento.place_obj.tipo_svg === 1 || (configuracion.hash_teatro === '6fG13COAYaetOZ1jZWTg' && evento.place_obj.id === 43)">
                    <TablaSectoresComponent
                        :zonas="zonas"
                        @goTo="zonaSeleccionada"
                    />
                </b-tab>
            </b-tabs>
        </b-col>
        <b-col cols="12" v-if="zona_seleccionada && zona_seleccionada.tipo_svg === '1' && paso === 2 && zona_seleccionada.with_seats">
            <SelectAsientosBloqueadosComponent 
                :zona="zona_seleccionada" 
                :asientos="asientos_seleccionados"
                @addSeat="asientoSeleccionado"
                @deleteSeat="asientoQuitado"
            />
        </b-col>   
        <b-col cols="12" v-else-if="zona_seleccionada && zona_seleccionada.tipo_svg === '2' && paso === 2">
            <SelectPlazasBloqueadasComponent 
                :region_id="zona_seleccionada.id" 
                :recinto_id="evento.place_obj.id"
                :evento_id="evento.id"
                :sesion_id="sesion.id"
                @clickPlaza="clickPlaza" 
                :key="resetKey"
            />
        </b-col>
        <b-col cols="12" v-if="zona_seleccionada && !zona_seleccionada.with_seats">
            <p>Seleccione el numero de entradas</p>
            <div class="form-group">
                <multiselect
                    v-model="n_entradas"
                    placeholder="Seleccione el nº de entradas"
                    :show-labels="false"
                    :options="options"
                    :allow-empty="false"
                    @select="actualizarDatos"
                />
            </div>
        </b-col>  
        <AsientosSeleccionados
            v-if="asientos.length > 0 || asientos_seleccionados.length > 0"
            :asientos="asientos"
            :asientos_seleccionados="asientos_seleccionados"
            :configuracion="configuracion"
            :descuento="descuento"
            :email="email"
            :loading="loading"
            @submit="submit"
        />         
    </b-row>
</template>

<script>
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
    import SelectAsientosBloqueadosComponent from '../../components/SelectAsientosBloqueadosComponent.vue';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent.vue';
    import SeccionesComponent from '@/components/frontend/events/compra/components/secciones/SeccionesComponent';
    import SelectButacasBloqueadosComponent from '../../components/SelectButacasBloqueadosComponent.vue';
    import SelectPlazasBloqueadasComponent from '../../components/SelectPlazasBloqueadasComponent.vue';
    import AsientosSeleccionados from './AsientosSeleccionados.vue';

    export default {
        props: {
            evento: {
                type: Object,
                required: true
            },
            sesion: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                zonas: [],
                zona_seleccionada: null,
                filas: [],
                asientos_seleccionados: [],
                descuento: 0,
                email: '',
                loading: false,
                plazasSeleccionadas: [],
                asientos: [],
                resetKey: 0,
                paso: 1,
                asientos_maximos: 10,
                n_entradas: 0
            }
        },
        created() {
            if(this.evento.place_obj.tipo_svg === 1 || (this.configuracion.hash_teatro === '6fG13COAYaetOZ1jZWTg' && this.evento.place_obj.id === 43)) {
                this.getZonas();
            }

            this.asientos_maximos = this.evento?.asientos_maximos ?? 100;
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            options() {
                let tope = this.asientos_maximos

                if(this.zona_seleccionada.total_libres < tope) {
                    tope = this.zona_seleccionada.total_libres;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            }
        },
        methods: {
            actualizarDatos() {
                this.asientos_seleccionados = [];

                for (let index = 0; index < this.n_entradas; index++) {
                    this.asientos_seleccionados.push({
                        fila: 0,
                        asiento: 0,
                        precios: this.zona_seleccionada.precios,
                        region_id: this.zona_seleccionada.id
                    })
                }
            },
            cambiarPaso(paso, reiniciar = false) {
                if(reiniciar){
                    this.reset()
                    this.getZonas();
                }
                this.paso = paso
            },
            clickPlaza(plazas, plazaSeleccionada) {
                const plazaEncontrada = plazas.find(plaza => plaza.id === plazaSeleccionada.id);

                if (plazaEncontrada) {
                    plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada; 

                    if (plazaEncontrada.seleccionada) {
                        if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                            this.plazasSeleccionadas.push(plazaSeleccionada);
                            this.asientos.push(plazaSeleccionada);
                            this.loading = false
                        }
                    } else {
                        const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                        if (index !== -1) {
                            this.plazasSeleccionadas.splice(index, 1);
                            this.asientos.splice(index, 1);
                            this.loading = false
                        }
                    }
                }
            },
            getZonas() {
                this.loading = true;
                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    this.getZonasAnexas();
                });
            },
            getZonasAnexas() {
                this.loading = true;
                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.anexas.index'), params).then(res => {
                    this.zonas = this.zonas.concat(res.data.data);

                }).finally(() => this.loading = false);
            },
            zonaSeleccionada(paso, zona) {
                this.cambiarPaso(paso)
                this.zona_seleccionada = zona;
            },
            goTo(paso, zona) {
                this.zona_seleccionada = zona
                this.paso = paso
            },
            asientoSeleccionado(fila, asiento, status) {
                this.asientos_seleccionados.push({
                    zona_id: this.zona_seleccionada.id,
                    fila: fila,
                    asiento: asiento,
                    id: status.info.id,
                    precios: this.zona_seleccionada.precios,
                    precioSelect: asiento.precioSelect ? asiento.precioSelect : null
                });
            },
            asientoQuitado(fila, asiento) {
                this.asientos_seleccionados = this.asientos_seleccionados.filter(objeto => !(objeto.fila === fila && objeto.asiento === asiento));
            },
            submit(asientos, emailValue, descuento, varios_pedidos, localizador) {
                if (this.asientos.length > 0) {
                    asientos = asientos.map(asiento => ({
                        id: asiento.id,
                        precioSelect: {
                            id: asiento.precioSelect.id
                        },
                        precios: asiento.precios.map(precio => ({
                            id: precio.id
                        }))
                    }));
                    this.asientos = asientos;
                } else {
                    asientos = asientos.map(asiento => ({
                        id: asiento.id,
                        region_id: this.zona_seleccionada.id,
                        precioSelect: {
                            id: asiento.precioSelect.id
                        },
                        precios: asiento.precios.map(precio => ({
                            id: precio.id
                        }))
                    }));
                    this.asientos_seleccionados = asientos;
                }
            
                this.email = emailValue;
                this.descuento = descuento;

                this.crearReserva(varios_pedidos, localizador);
            },
            crearReserva(varios_pedidos, localizador) {
                this.loading = true;
                let params = {}

                params = {
                    filters: {},
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    descuento: this.descuento,
                    varios_pedidos: varios_pedidos,
                    email: this.email
                };

                if(localizador){
                    params.localizador = localizador;
                }

                if(this.asientos_seleccionados.length > 0){
                    params.asientos = this.asientos_seleccionados;
                } else {
                    params.plazas = this.asientos;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.reservas.create'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.reset();
                    if(this.evento.place_obj.tipo_svg === 1) {
                        this.getZonas();
                    }  
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            reset() {
                this.zona_seleccionada = null;
                this.filas = [];
                this.asientos_seleccionados = [];
                this.plazasSeleccionadas = [];
                this.asientos = [];
                this.descuento = 0;
                this.email = '';
                this.resetKey += 1;
                this.paso = 1
            },
            customLabel({ descripcion, precio }) {
                return `${descripcion} – ${precio}€`
            },
            customLabelPlano({ description, precio }) {
                return `${description} – ${precio}€`
            }
        },
        components: {
            CleSvgComponent, SelectAsientosBloqueadosComponent, TablaSectoresComponent, SeccionesComponent, SelectButacasBloqueadosComponent, AsientosSeleccionados, SelectPlazasBloqueadasComponent
        }
    }
</script>
